export const bannerConstants = {
    GET_PRODUCT_BANNER_PENDING: 'GET_PRODUCT_BANNER_PENDING',
    GET_PRODUCT_BANNER_FULFILL: 'GET_PRODUCT_BANNER_FULFILL',
    GET_PRODUCT_BANNER_FAILED: 'GET_PRODUCT_BANNER_FAILED',
};
